import type { InvoiceCompany } from '../models/invoice-company.model';
import { PeriodFormatter } from './period-formatter';

export class InvoiceTypeLookup {
  constructor(
    private readonly _company: InvoiceCompany | null,
    private readonly _year: number,
    private readonly _month: number,
  ) {}

  public resolve(): string {
    if (!this._company) {
      return 'MONTHLY';
    }

    const baseType = this._company.generateInvoice ?? 'MONTHLY';
    if (!this._company.invoiceTypeHistory?.length) return baseType;
    return [...this._company.invoiceTypeHistory]
      .sort(
        (currentEntry, nextEntry) =>
          Number(currentEntry.period) - Number(nextEntry.period),
      )
      .reduce(
        (accumulated, entry) =>
          Number(this._period()) >= Number(entry.period)
            ? entry.invoiceType
            : accumulated,
        baseType,
      );
  }

  private _period(): string {
    return `${this._year}${new PeriodFormatter(this._month).padToTwoDigits()}`;
  }
}
